import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation } from '../../data/DataOperation.jsx';
import { DataOperation_CycleCommercial } from '../../data/DataOperation_CycleCommercial';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { HintVerticalPosition, HintWrapper } from '../Outils/HintWrapper';
import { MessageBars } from '../Outils/MessageBars';
import { Timeline } from '../Timeline/Timeline';

/****************************************************************
 PROPS:
    idOperation
    idCycleCommercial : == 0 si aucun cycle commercial

    onAffichePanelValidationCycleCommercial : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    cycleCommercial: {},
    operation: {},
    listCycleCommercial: [],
    periodeOuverture: null,
    idCycleCommercial: 0,

    titrePanel: 'Valider le cycle commercial',

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheValidationCycleCommercial extends Component {
    _creationContent() {
        const lendemainDeDateJour = new Date();

        lendemainDeDateJour.setDate(lendemainDeDateJour.getDate() + 1);

        let dateJour = new Date(Date.now());
        let existePeriodeOuverte = (this.state.periodeOuverture !== null);
        let dateDebutPeriode = (existePeriodeOuverte ? new Date(this.state.periodeOuverture.annee, new Date(this.state.periodeOuverture.dateDebut).getMonth(), 1) : null);
        let dateFinPeriode = (existePeriodeOuverte ? new Date(this.state.periodeOuverture.dateFin) : null);
        let operationClotureeCG = (this.state.operation.dateClotureCG !== null);
        let infoSurvolOperationClotureeCG = "Cette date n'est pas modifiable car l'opération est clôturée CG";
        let idCycleCommercialAAfficher = (this.state.idCycleCommercial);// < 3 ? this.state.idCycleCommercial + 1 : this.state.idCycleCommercial);
        let infoSurvolDisabled = "Cette date est modifiable dans l'identification programme";

        return (
            <Panel
                isOpen={this.props.onAffichePanelValidationCycleCommercial}
                headerText={this.state.titrePanel}
                type={PanelType.medium}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}


                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                    <Timeline listeEtapes={this.state.listCycleCommercial} etapeActive={idCycleCommercialAAfficher} />
                                </div>
                            </div>

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12">
                                    <HintWrapper
                                        content={<span>L'activation permet d'envoyer le statut du cycle commercial de l'opération aux flux commerciaux existants dans les mandats de l'opération (ex : siteweb, partenaires).</span>}
                                        verticalAlign={HintVerticalPosition.bottom}
                                        verticalOffset={5}
                                    >
                                        <Toggle
                                            label="Activer le cycle commercial"
                                            onText={`Oui, le ${Scriba.date().stringDateFormatCourt(this.state.operation.datePassageAvantPremiere === undefined || this.state.operation.datePassageAvantPremiere === null ? new Date() : this.state.operation.datePassageAvantPremiere)}`}
                                            offText="Non"
                                            disabled={(this.state.operation.dateLancementCommercialisationPrevue === null || this.state.operation.dateLancementCommercialisationPrevue === undefined)
                                                && (this.state.operation.dateLancementCommercialisation === null || this.state.operation.dateLancementCommercialisation === undefined)}
                                            checked={this.state.operation.passageAvantPremiere}
                                            onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "operation", "passageAvantPremiere", isChecked)}
                                        />
                                    </HintWrapper>
                                </div>
                            </div>

                            {idCycleCommercialAAfficher === 1 ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12">
                                        <EUIDatePicker
                                            label="Date prévisionnelle lancement de commercialisation"
                                            minDate={existePeriodeOuverte ? dateDebutPeriode : lendemainDeDateJour}
                                            onSelectDate={date => this._onSelectDate(date, 'operation', 'dateLancementCommercialisationPrevue')}
                                            value={this.state.operation.dateLancementCommercialisationPrevue}
                                        />
                                    </div>
                                </div>
                                : null
                            }

                            {idCycleCommercialAAfficher >= 2 ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12">
                                        <EUIDatePicker
                                            disabled={operationClotureeCG}
                                            label="Date réelle lancement de commercialisation"
                                            maxDate={existePeriodeOuverte ? dateFinPeriode : dateJour}
                                            minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                                            onSelectDate={date => this._onSelectDate(date, 'operation', 'dateLancementCommercialisation')}
                                            title={operationClotureeCG ? infoSurvolOperationClotureeCG : null}
                                            value={this.state.operation.dateLancementCommercialisation}
                                        />
                                    </div>
                                </div>
                                : null
                            }

                            {idCycleCommercialAAfficher >= 3 ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12">
                                        <EUIDatePicker
                                            disabled
                                            label="Date achat terrain"
                                            maxDate={dateJour}
                                            onSelectDate={date => this._onSelectDate(date, 'operation', 'dateAchatTerrain')}
                                            title={infoSurvolDisabled}
                                            value={this.state.operation.dateAchatTerrain}
                                        />
                                    </div>
                                </div>
                                : null
                            }

                            {idCycleCommercialAAfficher === 4 ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12">
                                        <EUIDatePicker
                                            disabled={operationClotureeCG}
                                            label="Date réelle de livraison"
                                            maxDate={dateJour}
                                            minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                                            onSelectDate={date => this._onSelectDate(date, 'operation', 'dateLivraison')}
                                            title={operationClotureeCG ? infoSurvolOperationClotureeCG : null}
                                            value={this.state.operation.dateLivraison}
                                        />
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees(idCycleCommercial, idOperation, idCycleCommercialClick) {
        let idCycleCommercialTrav = (idCycleCommercial != undefined && idCycleCommercial != 0 ? idCycleCommercial :
            ((idCycleCommercialClick != undefined && idCycleCommercialClick != 0) ? idCycleCommercialClick : 0));

        if (idCycleCommercialTrav > 0) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du cycle commercial de l\'opération'
            });

            let chargementCycleCommercial = DataOperation_CycleCommercial._chargementCycleCommercial(idCycleCommercialTrav, idOperation);

            chargementCycleCommercial
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let cycleCommercialTrav = objetData[0];
                        let operationTrav = objetData[1];
                        let listeDesPromisesAExecuter = [];

                        operationTrav.passageAvantPremiere = (operationTrav.datePassageAvantPremiere !== null ? true : false);

                        let stateTemp = {};
                        stateTemp.idOperation = idOperation;
                        stateTemp.idCycleCommercial = idCycleCommercialTrav;
                        stateTemp.titrePanel = (cycleCommercialTrav.libelle !== null ? `Valider le cycle commercial "${cycleCommercialTrav.libelle}"` : 'Valider le cycle commercial "Avant-Première"');
                        stateTemp.cycleCommercial = cycleCommercialTrav;
                        stateTemp.operation = operationTrav;
                        stateTemp.periodeOuverture = objetData[2];

                        let chargementCycleCommercial = DataOperation._chargementFicheIdentification_CycleCommercial(idOperation);
                        listeDesPromisesAExecuter.push(chargementCycleCommercial.then(responseFetch => {
                            this._onChargementCycleCommercial(responseFetch, this, stateTemp);
                        }));

                        Promise.all(listeDesPromisesAExecuter).then(() => { Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp); });

                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            //pas de cycle commercial => on charge ts les cycles commerciaux
            let listeDesPromisesAExecuter = [];
            let stateTemp = {};

            stateTemp.idOperation = idOperation;
            stateTemp.idCycleCommercial = 1;
            stateTemp.hideMessageBarWarning = false;
            stateTemp.warningMessage = 'Veuillez sélectionner un cycle commercial';

            let chargementCycleCommercial = DataOperation._chargementFicheIdentification_CycleCommercial(idOperation);
            listeDesPromisesAExecuter.push(chargementCycleCommercial.then(responseFetch => {
                this._onChargementCycleCommercial(responseFetch, this, stateTemp);
            }));

            Promise.all(listeDesPromisesAExecuter).then(() => { Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp); });
        }
    }

    _onChargementCycleCommercial = (responseFetch, _this, stateTemp) => {
        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, _this);

        if (retourVerif === null) {
            let objetData = responseFetch.reponseAPIobjet;
            let listCycleCommercialTrav = [];

            objetData.forEach(function (cycle, index) {
                listCycleCommercialTrav.push({
                    numEtape: cycle.idCycleCommercial,
                    icone: (cycle.modifierLe !== null ? 'CompletedSolid' : 'PageRight'),
                    nomEtape: cycle.libelle,
                    sousTitre: (cycle.dateAffichee !== null ? Scriba.date().stringDateFormatLong(cycle.dateAffichee) : ''),
                    tooltip: (cycle.modifierLe !== null ? `Mis à jour le ${Scriba.date().stringDateHeureFormatCourt(cycle.modifierLe)}` : ''),
                    onClick: () => (cycle.modifierLe == null ? _this._chargementDonnees(0, _this.props.idOperation, cycle.idCycleCommercial) : null)
                });
            });

            stateTemp.listCycleCommercial = listCycleCommercialTrav;
        }
        else {
            Immocom.onTraitementErreurAvecState(_this, stateTemp, retourVerif, responseFetch);
        }
    }

    _validationFormulaire(item) {
        let estValide = true;

        //// Si l'objet n'est pas vide
        //if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
        //    let idCycleCommercialTrav = this.state.cycleCommercial.idCycleCommercial;

        //    if (idCycleCommercialTrav === 1) {
        //        estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateLancementCommercialisationPrevue);
        //    }
        //    else {
        //        estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateLancementCommercialisation);

        //        if (idCycleCommercialTrav === 3) {
        //            estValide = estValide && Scriba.formulaire().nEstPasVide(item.dateAchatTerrain);
        //        }
        //    }
        //}
        //else {
        //    estValide = false;
        //}

        return estValide;
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du cycle commercial de l\'opération'
        });

        let enregistrementCycleCommercial = DataOperation_CycleCommercial._enregistrementCycleCommercial(this.state.idCycleCommercial, this.props.idOperation, this.state.operation);

        enregistrementCycleCommercial
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onRenderFooterContent = () => {
        let boutonActif = this._validationFormulaire(this.state.operation);

        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        this._chargementDonnees(this.props.idCycleCommercial, this.props.idOperation, 1);
    }

    _onSelectDate(value, objet, champ) {
        var valeurDate = Scriba.date().getChaineISOFromDate(value, true);
        Scriba.state().setObjetPropriete(this, objet, champ, valeurDate);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        return this._creationContent();
    }
}